<div class="order-status-rating-text ods-typography-body-s-bold">{{ title | translate }}:</div>
<rating [size]="32" [rating]="rating" [disabled]="state === 'RATED'" (changeRating)="onChangeRating($event)"></rating>
